import { render, staticRenderFns } from "./ActivityTreeNodeBookmarksUrlExport.global.vue?vue&type=template&id=2c3db7f9&lang=pug&"
import script from "./ActivityTreeNodeBookmarksUrlExport.global.vue?vue&type=script&lang=ts&"
export * from "./ActivityTreeNodeBookmarksUrlExport.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports